jQuery(function($) {
    var delayTimer;
    var currentPage = 1;
    var maxPages = parseInt($('#max-pages').val());

    function sendRequest(resetPosts) {
      var filter = $('#articlefilter');
      $('#loading').show();
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize() + '&paged=' + currentPage,
        type: filter.attr('method'),
        dataType: 'json',
        success: function(response) {
          if (resetPosts) {
            $('#articleresponse').html(response.result); // Reset the posts with the new results
          } else {
            $('#articleresponse').append(response.result); // Append the new results
          }
          maxPages = parseInt(response.max_pages); // Update the maxPages variable with the value from the response
          if (currentPage >= maxPages || response.result.trim() === '') {
            $('#load-more-button').hide(); // Hide the button if all posts have been loaded or there are no more posts
          } else {
            $('#load-more-button').show(); // Show the button if there are more posts to load
          }
        },
        complete: function() {
          $('#loading').hide();
        }
      });
    }

    sendRequest(false); // Send the initial request when the page finishes loading

    $('#articlefilter input').on('change', function() {
      clearTimeout(delayTimer); // Clear the previous timer
      delayTimer = setTimeout(function() {
        currentPage = 1; // Reset the current page number to 1 when the filter changes
        var resetPosts = true; // Flag to indicate if the existing posts should be reset

          $('#articleresponse').empty(); // Empty the existing posts
          $('#load-more-button').show(); // Show the "Load More" button

        sendRequest(resetPosts); // Send the request with the updated filter
      }, 500);
    });

    // Add a click event listener to the "Load More" button
    $('#load-more-button').on('click', function() {
      currentPage++; // Increment the current page number
      if (currentPage <= maxPages) {
        sendRequest(false); // Send a new request for the next page of posts
      } else {
        $(this).hide(); // Hide the button if all posts have been loaded
      }
    });
  });





// Get all radio buttons with the name "categoryfilter[]"
var radioButtons = document.querySelectorAll('input[name="categoryfilter[]"]');

// Loop through each radio button
for (var i = 0; i < radioButtons.length; i++) {
  // Add an event listener for change event
  radioButtons[i].addEventListener('change', function() {
    // Remove the "active" class from all labels
    var labels = document.querySelectorAll('label');
    for (var j = 0; j < labels.length; j++) {
      labels[j].classList.remove('active');
    }

    // Check if the current radio button is checked
    if (this.checked) {
      // Add the "active" class to the label of the active radio button
      this.parentNode.classList.add('active');
    }
  });
}
